module.exports = __webpack_public_path__ + "static/media/cafe_popular.e1f82073.webp";